<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">Charge Group</div>
    </div>
    <div class="action_btn">
      <button class="add_new_btn" (click)="addNewRecord()" *RequiresPermission="{permissionIds: [PermissionConstants.CHARGE_GROUP.CREATE]}">
        <img src="assets/icons/plus_icon.svg" height="20" width="20">Add New
      </button>
    </div>
  </div>
</header>

<div class="search_bar_with_table" *RequiresPermission="{permissionIds: [PermissionConstants.CHARGE_GROUP.LIST]};fallback: true">
  <app-tos-table
    [stats]="tableStats"
    [searchBarConfig]="ChargeGroupConfig.searchBarConfig"
    [filterConfig]="ChargeGroupConfig.filterConfig"
    [showTableStats]="true"
    [tableMeta]="tableMeta"
    [tableMenuOptions]="menuOptions"
    [(dataListRequest)]="tableListRequest"
    [dataListResponse]="tableListData"
    [(selectedItems)]="selectedItems"
    (tosTableAction)="getTableList()"
    (tableMenuOptionSelected)="handleOptionSelected($event)"
  ></app-tos-table>
</div>
